import { useState } from 'react';
import { createPortal } from 'react-dom';

import { loadable } from '@Components/Utilities/SandhillsLoadable';
import TranslationText from '@Components/Utilities/TranslationText';
import translator from '@Components/Utilities/Translator';

const EmptyLegQuoteModal = loadable(() => import('@Components/Shared/Modals/EmptyLegQuoteModal'), true);

const ListingQuoteCard = (props) => {
    const [showEmptyLegQuoteModal, setShowEmptyLegQuoteModal] = useState(false);

    const onEmptyLegQuoteModalToggle = () => {
        setShowEmptyLegQuoteModal(showEmptyLegQuoteModal => !showEmptyLegQuoteModal);
    };

    const calculateDepartsIn = () => {
        var timeSpan = new Date(props.DepartureTime?.toString()) - new Date();
        var totalHours = Math.floor(timeSpan / (1000 * 60 * 60));
        var days = Math.floor(totalHours / 24);
        var hours = totalHours % 24;
        var minutes = Math.floor((timeSpan % (1000 * 60 * 60)) / (1000 * 60));

        if (days >= 7) {
            var weeks = days / 7;
            return (`${weeks} ${weeks > 1 ? translator.translate('sandhills.weeks') : translator.translate('sandhills.week') } on ${props.DepartureDate}`);
        }
        else if (days > 0) {
            return(`${days} ${days > 1 ? translator.translate('sandhills.days') : translator.translate('sandhills.day')} on ${props.DepartureDate}`);
        }
        else if (hours > 0) {
            return(`${hours} ${hours > 1 ? translator.translate('sandhills.hours') : translator.translate('sandhills.hour')} on ${props.DepartureDate}`);
        }
        // There will never be a case where the departure time is less than 1 hour away because there is a 2 hour cutoff with a 15 min cache on those results.
    }

    return (
        <div className="latest-listings">
            {/*{props.ImgUrl &&*/}
            {/*    <div className="latest-img">*/}
            {/*        <div className="latest-date">{props.DepartureDate}</div>*/}
            {/*        <button className='quote-card-button' onClick={() => setShowEmptyLegQuoteModal(true)}>*/}
            {/*            <img src={props.ImgUrl} />*/}
            {/*        </button>*/}
            {/*    </div>*/}
            {/*}*/}
            <div className="latest-details">
                <div className="latest-name">
                    <span>{props.DepartureLocation} to {props.ArrivalLocation}</span>
                </div>
                <div className="latest-time"><TranslationText tKey='sandhills.tradesites.mvc.departsin' /> <strong>{calculateDepartsIn()}</strong></div>
                <button className="block-btn ts-rounded-button" onClick={() => setShowEmptyLegQuoteModal(true)}><TranslationText tKey='sandhills.requestaquote' /></button>
            </div>
            {showEmptyLegQuoteModal && createPortal(
                <EmptyLegQuoteModal
                    {...props.EmptyLeg}
                    toggleEmptyLegQuoteModal={onEmptyLegQuoteModalToggle}
                    IsEmployee={props.ShowEmployeeOnlyInfo}
                />,
                document.body
            )}
        </div>
    );
};

export default ListingQuoteCard;